import PanelSection from 'components/fulcrum/panelSection/PanelSection'

import SupportTeam from '../../Project/SupportTeam'



import React, { Component } from 'react'
import { connect } from 'react-redux'
import { compose } from 'recompose'
import styles from './styles.scss'
import {
  fetchSupportTeam,
} from 'containers/Project/SupportTeam/actions'
import CSSModules from 'helpers/CSSModulesUtil'

const mapDispatchToProps = (dispatch) => {
  return {
    fetchSupportTeam: (projectId) => dispatch(fetchSupportTeam(projectId))
  }
}


class Specifications extends Component {
  render() {
    return(    
    <PanelSection>
      <div styleName='wrapper'>
        <SupportTeam id={this.props.projectId} />
      </div>
    </PanelSection>)
  }
}
const withStyles = CSSModules(styles)
const withConnect = connect(null, mapDispatchToProps)
export default compose(
  withConnect,
  withStyles
)(Specifications)
